import React, { useLayoutEffect } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

interface StackProps {
  id: string;
  data: object[];
}

const Stack: React.FC<StackProps> = ({ id, data }) => {
  // const chart = useRef(null);

  useLayoutEffect(() => {
    let x = am4core.create(id, am4charts.XYChart);
    x.hiddenState.properties.opacity = 0;
      x.background.visible = false;
      x.language.locale["_decimalSeparator"] = ",";
      x.language.locale["_thousandSeparator"] = "."; 

    // Add data
    x.data = data;

    //Stack Colors
    x.colors.list = [
      am4core.color("#f91054"),
      am4core.color("#fcc003"),
      am4core.color("#00162b"),
      am4core.color("#00162b"),
      am4core.color("#656061")
    ];
    x.padding(30, 30, 10, 30);

    // Create axes
    var categoryAxis = x.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "category";
    categoryAxis.renderer.grid.template.opacity = 0;
    categoryAxis.renderer.labels.template.fill = am4core.color("#00162b");
    //categoryAxis.renderer.labels.template.fontSize = 16;

    var valueAxis = x.xAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.max = 100;
    valueAxis.strictMinMax = true;
    valueAxis.calculateTotals = true;
    valueAxis.renderer.minWidth = 50;
    valueAxis.renderer.labels.template.fill = am4core.color("#00162b");
    valueAxis.renderer.grid.template.disabled = true;
    valueAxis.renderer.baseGrid.disabled = true;
    // This adapter adds custom text to the label
    valueAxis.renderer.labels.template.adapter.add(
      "text",
      (label, target, key) => {
        return label + "%";
      }
    );

    // Create series
    function createSeries(field: any, name: any) {
      var series = x.series.push(new am4charts.ColumnSeries());
      series.columns.template.tooltipText =
        "{name}: {valueX.formatNumber('#,###.')} - {valueX.totalPercent.formatNumber('#.00')}%";
      series.dataFields.valueX = field;
      series.dataFields.categoryY = "category";
      series.dataFields.valueXShow = "totalPercent";
      series.stacked = true;
      series.name = name;
      series.calculatePercent = true;

      var labelBullet = series.bullets.push(new am4charts.LabelBullet());
      labelBullet.locationX = 0.5;
      labelBullet.label.text = "{valueX.formatNumber('#,###.')}";
      labelBullet.label.fill = am4core.color("#fff");
    }

    createSeries("Downtrade", "Downtrade");
    createSeries("Impulse", "Impulse");
    createSeries("On Premise", "On Premise");
    createSeries("Retail", "Retail");
    createSeries("Wholesaler", "Wholesaler");

    /*--------------------------------------------------------------------------------------*/
    //chart.current = x;

    return () => {
      x.dispose();
    };
  });

  return <div className="chart" id={id}></div>;
};

export default Stack;
